// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n._1haIliFHlpQmE8SE4JlSLn { \r\n    position: relative;\r\n}\r\n\r\n\r\n.PCN4hZQqRGQey04lKO7cH {\r\n    position: absolute;\r\n    top: 24px;\r\n    left: 50%;\r\n\r\n    width: 240px;\r\n    margin-left: -120px;\r\n\r\n    background: #fff;\r\n    padding: 12px;\r\n    border-radius: 3px;\r\n\r\n    text-align: center;\r\n    color: #000;\r\n    font-size: 11px;\r\n\r\n    cursor: pointer;\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_1haIliFHlpQmE8SE4JlSLn",
	"notification": "PCN4hZQqRGQey04lKO7cH"
};
module.exports = exports;
